import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Clear = ({ show, onClose }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const special_category = [
        { value: 1, label: "1 Month" },
        { value: 2, label: "3 Month" },
        { value: 3, label: "6 Month" },
        { value: 4, label: "1 Year" },
    ];

    const [selectedvalue, setvalue] = useState(null);

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        

        if (!selectedvalue) {
            newErrors.val = "This Field is Required.";
        }

        return newErrors;
    };


    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = {
            period: selectedvalue
        };

        axios.post(`${baseURL}/cronjob_monitor/delete`, postData)
            .then(response => {
                onClose();
                toast.success("Cronjob Logs Cleared Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Cronjob Logs Clear Failed");
            });
    };

    return (
        <Modal show={show} size="m">
            <style>
                {`
          .table-container {
            max-height: 350px;
            overflow-y: auto;
            display: block;
          }

          .table-container table {
            border-collapse: collapse;
            width: 100%;
          }

          .table-container thead th {
            position: sticky;
            top: 0;
            background-color: #025D3A;
            z-index: 0;
          }
        `}
            </style>
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Clear Cronjob Log</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-3">
                        <div className='col-lg-12 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w600 fs-7'>Clear</label>
                            <Select
                                placeholder="Select Clear Data"
                                options={special_category}
                                onChange={(sel) => setvalue(sel.value)}
                            />
                            {errors.val && <div className="text-danger fs-8 mt-1">{errors.val}</div>}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
                        <Link className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Link className="btn btn-sm btn-primary" onClick={handleSubmit}>Clear Log</Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Clear;
